'use client';

import * as React from 'react';
import { Eye, EyeOff } from 'lucide-react';

import { cn } from '@/lib/utils';
import { Input } from './input';

export interface PasswordInputProps extends Omit<React.ComponentProps<'input'>, 'type'> {
  /**
   * Optional: Show password by default
   * @default false
   */
  defaultVisible?: boolean;
}

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, defaultVisible = false, ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(defaultVisible);

    const togglePasswordVisibility = () => {
      setShowPassword((prev) => !prev);
    };

    return (
      <div className="relative">
        <Input
          type={showPassword ? 'text' : 'password'}
          className={cn('pr-10', className)}
          ref={ref}
          {...props}
        />
        <button
          type="button"
          onClick={togglePasswordVisibility}
          className="absolute right-0 top-0 h-full px-3 py-2 hover:bg-transparent min-w-[44px] flex items-center justify-center"
          aria-label={showPassword ? 'Hide password' : 'Show password'}
          tabIndex={-1}
        >
          {showPassword ? (
            <EyeOff className="h-4 w-4 text-muted-foreground transition-colors hover:text-foreground" />
          ) : (
            <Eye className="h-4 w-4 text-muted-foreground transition-colors hover:text-foreground" />
          )}
        </button>
      </div>
    );
  },
);
PasswordInput.displayName = 'PasswordInput';

export { PasswordInput };
